import { TableName } from "../../tables"

export enum Action {
    GET_ALL = 'GetAll',
    GET = 'Get',
    GET_BY_PARAMS = 'GetByParams',
    GET_BY_IDS = 'GetByIds',
    SAVE = 'Save',
    REMOVE = 'Remove'
}

export type TableActions = {
    tableName: TableName,
    indexName?: string,
    actions: Action[]
}

export type Permission = {
    tableNames: TableName[],
    isIndex?: boolean,
    hasTKey: boolean,
    actions: Action[]
}
